<template>
  <span
    :class="pulseClasses"
    class="skeletons-TextSkeleton bg-skeleton"
    aria-hidden="true"
    data-test="container">
    <span
      v-html="spaceChars"
      data-test="characters"
      class="whitespace-nowrap">
    </span>
  </span>
</template>

<script>
export default {
  name: 'TextSkeleton',
  props: {
    /**
     * When pulse is true and used within another skeleton
     * component, the pulsing increases.
     *
     * If this component is used on its own somewhere, it won't
     * pulse unless this is true.
     */
    pulse: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Number of character spaces to put in as a placeholder.
     * Basically it allows us width without needing to specify
     * a width. It can be randomised.
     */
    characters: {
      type: Number,
      required: false,
      default: 10,
    },
  },
  computed: {
    pulseClasses() {
      return {
        'animate-pulse': this.pulse,
      };
    },
    spaceChars() {
      return '&nbsp;'.repeat(this.characters);
    },
  },
};
</script>
